<ng-container *ngIf="photo; else noPhoto">
  <div class="rounded-circle relative avatar-container" [ngClass]="{'editable': editable}">
    <img [src]="photo | imagePathFormat"
         alt="avatar" class="rounded-circle img-fluid avatar-photo"/>
    <div *ngIf="editable"
         class="editable-container"
    >
      <div class="edit-block">
        <img
          src="/assets/vectors/edit.svg"
          alt="edit"
          (click)="fileInput.click()"
        >
      </div>
      <div>
        <img
          src="/assets/vectors/trash.svg"
          alt="delete" class="delete-icon"
          (click)="deleteAvatar()"
        >
      </div>
    </div>
  </div>
  <input type="file" accept="image/*" #fileInput (change)="fileChangeEvent($event)" class="visually-hidden-file">

</ng-container>
<ng-template #noPhoto>
  <div class="rounded-circle avatar-container empty-avatar relative" [ngClass]="{'editable': editable}">
    <div class="text">
      {{firstname | slice: 0: 1}}
    </div>

    <div *ngIf="editable"
         class="editable-container"
         (click)="fileInput.click()"
    >
      <input type="file" accept="image/*" #fileInput (change)="fileChangeEvent($event)" class="visually-hidden-file">
      <img src="/assets/vectors/edit.svg" alt="edit" class="empty-edit">
    </div>
  </div>
</ng-template>
